import { DataProviderQueryStatus } from '../types';

export const combineQueryStatuses = (statuses: DataProviderQueryStatus[]) => {
  if (statuses.every((status) => status === DataProviderQueryStatus.Success)) {
    return DataProviderQueryStatus.Success;
  }
  if (statuses.some((status) => status === DataProviderQueryStatus.Error)) {
    return DataProviderQueryStatus.Error;
  }
  if (statuses.some((status) => status === DataProviderQueryStatus.Fetching)) {
    return DataProviderQueryStatus.Fetching;
  }
  return DataProviderQueryStatus.Idle;
};
